import {LitElement, html, css} from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { SldsBaseElement } from '../components/slds-base-element.js';
import store from '../src/store';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { fetchComments, postComment, uploadImage, commentReaction } from '../src/apiActions';
import { resetStateField } from '../src/store';
import { getTimePassed } from '../src/apiCommon';
import "./single-comment.js";
import "../components/slds-combobox.js";
import { statusArray } from "../src/apiCommon";

@customElement('feed-view')
class FeedView extends connect(store)(SldsBaseElement) {
  @property({ type: String }) postUrl = '';
  @property({ type: Array }) comments = [];
  @property({ type: String }) accessToken = '';
  @property({ type: Boolean }) submitting = false;
  @property({ type: String }) replyToCommentId = '';
  @property({ type: String }) requestCommentId = '';
  @property({ type: Boolean }) hideTopForm = false;
  @property({ type: Boolean }) hideBottomForm = false;
  @property({ type: Number }) totalCommentCount = 0;
	@property({ type: Object }) uploadedImage = null;
	@property({ type: Object }) likedLookup = {};
	@property({ type: Object }) dislikedLookup = {};
	@property({ type: Object }) user = null;
	@property({ type: Object }) orderSelected = {title: 'Hot comments', id: 'hotDesc'}; // Hot comments or New comments
	@property({ type: Array }) orderOptions = [
		{title: 'Hot comments', id: 'hotDesc'}, 
		{title: 'New comments', id: 'newDesc'}
	];
	statusLookup = {};

	constructor() {
    super();
		this.statusLookup = statusArray.reduce((acc, status) => {
			acc[status.id] = status;
			return acc;
		}, {});
  }

  stateChanged(state) {
    this.accessToken = state.accessToken;
		if (state.user) {
			this.user = state.user;
		}
		if (state.uploadedImage) {
			this.uploadedImage = state.uploadedImage;
			store.dispatch(resetStateField('uploadedImage'));
		}
		if (state.comments) {
			const comments = state.comments;
			if (comments.length > 0 && comments[0].comment_level > 0) {
				const parent_id = comments[0].parent_id;
				for (let i = 0; i < this.comments.length; i++) {
					if (this.comments[i].id === parent_id) {
						this.comments[i].replies = comments;
						this.comments[i].expanded = true;
						this.totalCommentCount += comments.length;
						this.requestUpdate();
						break;
					}
				}
			}
			else {
				// Save mutated comment values such as .replies and .expanded before setting the new comments
				const mutatedComments = comments.map(comment => {
					return {...this.comments.find(c => c.id === comment.id), ...comment};
				});
				this.comments = mutatedComments;
				this.totalCommentCount = comments.length;
				this.requestUpdate();
			}
			store.dispatch(resetStateField('comments'));
		}
		if (state.createdComment) {
			if (!(this.replyToCommentId==="")) {
				const respondingToComment = this.comments.find(c => c.id === this.requestCommentId);
				if (!respondingToComment.expanded) {
					this.loadReplies(this.requestCommentId, false);
					this.requestUpdate();
				}
			}
			this.shadowRoot.querySelector('.slds-publisher__input').value = '';
			this.submitting = false;
			this.replyToCommentId = '';
			this.requestCommentId = '';
			setTimeout(() => {
				this.loadComments();
			}, 50);
			store.dispatch(resetStateField('createdComment'));
		}
  }

  updated(changedProperties) {
    if (changedProperties.has('postUrl') && this.postUrl) {
      this.loadComments();
    }
  }

  static styles = [
	super.styles,
	css`
		.dark textarea {
			color: #181818;
		}
		.slds-post {
			background: var(--background-color);
		}
		.slds-feed__item-comments {
			background: var(--replies-background, #f3f3f3);
			border-bottom: 1px solid var(--border-color, #e5e5e5);
			border-top: 1px solid var(--border-color, #e5e5e5);
		}
		.slds-feed {
			max-width: initial;
		}
		.slds-box {
			border: 1px solid var(--border-color, #e5e5e5);
		}
		.slds-button--icon-border, .slds-button--icon-border-filled, .slds-button_icon-border, .slds-button_icon-border-filled {
			border: 1px solid var(--border-color, #e5e5e5);
		}
		.slds-publisher__input {
			background-color: var(--background-color);
			color: var(--text-color);
		}
		.slds-publisher--comment.slds-has-focus, .slds-publisher_comment.slds-has-focus {
			background-color: var(--background-color);
		}
		.slds-current-color {
			fill: #0176d3;
		}
		button:hover .slds-current-color, button:focus .slds-current-color {
			fill: #0176d3;
		}
		.background {
			min-height: 20rem;
			display: inline-block;
		}
		img, video {
			object-fit: contain;
			max-height: 20rem;
			margin-left: auto;
			margin-right: auto;
		}
		.slds-post__footer-action.slds-is-active, .slds-post__footer-action:focus, .slds-post__footer-action:hover, .slds-text-link {
			color: #0176d3 !important;
		}
		.slds-button {
			--sds-c-button-text-color: #0176d3;
		}
		.slds-post__footer-action, .slds-text-heading--label-normal, .slds-text-heading_label-normal, .slds-text-title, .slds-text-color--weak, .slds-text-color_weak {
			color: var(--text-color);
		}
	`
	];

  async loadComments() {
		console.log("loadComments", this.postUrl, this.orderSelected.id)
		store.dispatch(fetchComments(this.postUrl, null, this.orderSelected.id));
  }

  expandTextarea(event) {
		// Get the closest parent element with the class 'slds-publisher'
		if (event) {
			const textarea = event.target.closest('.slds-publisher');
			textarea.classList.add('slds-is-active', 'slds-has-focus');
		}
		else {
			const textarea = this.shadowRoot.querySelector('.slds-publisher');
			textarea.classList.add('slds-is-active', 'slds-has-focus');
		}
  }

  collapseTextarea() {
    // const textarea = this.shadowRoot.querySelector('.slds-publisher');
    // textarea.classList.remove('slds-is-active', 'slds-has-focus');
  }

  handleSubmit(event) {
    event.preventDefault();
		// Post the comment to the backend
		const comment = this.shadowRoot.querySelector('.slds-publisher__input').value;
		this.submitting = true;
		if (!(this.requestCommentId === this.replyToCommentId)) {
			const postUrl = this.postUrl;
			const commentId = this.requestCommentId;
			setTimeout((() => { // First attempt at 50ms
				store.dispatch(fetchComments(postUrl, commentId));
				setTimeout((() => { // Second attempt at 300ms
					store.dispatch(fetchComments(postUrl, commentId));
					setTimeout((() => { // Third attempt at 600ms
						store.dispatch(fetchComments(postUrl, commentId));
					}).bind(this), 600);
				}).bind(this), 300);
			}).bind(this), 50);
		}
		store.dispatch(postComment(this.postUrl, this.requestCommentId, comment, this.uploadedImage));
		if (this.uploadedImage) {
			this.uploadedImage = null;
		}
  }

  // Prevent form submission when cancel is clicked
  handleCancel(event) {
    event.preventDefault();
		this.replyToCommentId = '';
		this.requestCommentId = '';
		this.requestUpdate("replyToCommentId");
		this.submitting = false;
		// Iterate over all .slds-publisher elements and remove the active and focus classes
		this.shadowRoot.querySelectorAll('.slds-publisher').forEach(textarea => {
			textarea.classList.remove('slds-is-active', 'slds-has-focus');
		});
  }

  toggleReplies(commentId, replyId = null) {
		if (replyId) {
			// Find which parent comment this reply is for
			// Search .replies for commen
			this.replyToCommentId = replyId;
		}
		else
		{
			this.replyToCommentId = commentId;
		}
		this.requestCommentId = commentId;
		this.requestUpdate("replyToCommentId");
		setTimeout(() => {
			this.expandTextarea();
			this.shadowRoot.querySelector('textarea').focus();
		});
  }

  getVideoOrImage(files) {
		if (files.light && !files.default) {
			files.default = files.light;
		}
    if (files && files.default) {
      const fileUrl = files.default.file_url;
      const ext = fileUrl.split(".").pop();
      if (ext === "webp") {
        return html`<a href="${fileUrl}" target="_blank"><img src="${fileUrl}"></a>`;
      }
      else if (ext === "webm") {
        return html`<video width="100%" autoplay="autoplay" muted="muted" loop>
          <source src="${fileUrl}" type="video/webm">
          Your browser does not support the video tag.
        </video>`;
      }
      // files.default
      // debugger;
    }
  }

  getVideoOrImageUploadedImage(uploadedImage) {
    if (uploadedImage && uploadedImage.fileUrl) {
      const fileUrl = uploadedImage.fileUrl;
      const ext = fileUrl.split(".").pop();
			const alt = uploadedImage.message;
      if (ext === "webp") {
        return html`<img src="${fileUrl}" alt="${alt}">`;
      }
      else if (ext === "webm") {
        return html`<video width="100%" controls>
          <source src="${fileUrl}" type="video/webm">
          Your browser does not support the video tag.
        </video>`;
      }
    }
  }

	loadReplies(commentId, expanded) {
		console.log("loadReplies,expanded", commentId, expanded);
		if (expanded) {
			for (let i = 0; i < this.comments.length; i++) {
				if (this.comments[i].id === commentId) {
					this.totalCommentCount-=this.comments[i].comment_count;
					this.comments[i].replies = null;
					this.comments[i].expanded = false;
					this.requestUpdate();
					break;
				}
			}
		}
		else {
			for (let i = 0; i < this.comments.length; i++) {
				if (this.comments[i].expanded) {
					this.totalCommentCount-=this.comments[i].comment_count;
					this.comments[i].replies = null;
					this.comments[i].expanded = false;
					this.requestUpdate();
					break;
				}
			}
			store.dispatch(fetchComments(this.postUrl, commentId));
		}
	}

	likeComment(comment, event) {
		if (comment.downvote) {
			comment.downvote = false;
			comment.downvotes--;
		}
		if (comment.upvote) {
			comment.upvote = false;
			comment.upvotes--;
		}
		else {
			comment.upvote = true;
			comment.upvotes++;
		}
		this.requestUpdate("likedLookup");
		store.dispatch(commentReaction(comment, 'upvote', comment.upvote));
		console.log("likeComment", comment, event);
	}

	dislikeComment(comment, event) {
		if (comment.upvote) {
			comment.upvote = false;
			comment.upvotes--;
		}
		if (comment.downvote) {
			comment.downvote = false;
			comment.downvotes--;
		}
		else {
			comment.downvote = true;
			comment.downvotes++;
		}
		this.requestUpdate("dislikedLookup");
		store.dispatch(commentReaction(comment, 'downvote', comment.downvote));
		console.log("dislikeComment", comment, event);
	}

	getLikes(comment) {
		var label = comment.upvotes > 1 ? `${comment.upvotes} ` : ``;
		return comment.upvote ? `${label}Liked` : `${label}Like`;
	}

	getDislikes(comment) {
		// if has more than 0 downvotes, return X disliked, otherwise return whether the current user disliked it along with the number of downvotes
		var label = comment.downvotes > 1 ? `${comment.downvotes} ` : ``;
		return comment.downvote ? `${label}Disliked` : `${label}Dislike`;
	}

	renderReply(comment, reply) {
		return html`
			<div class="slds-media__figure slds-p-top_xx-small">
				<a href="/user/${reply.username}" class="slds-avatar slds-avatar_circle slds-avatar_medium">
					<img alt="${reply.posted_by.displayName}" src="${reply.posted_by.photoURL}" title="${reply.posted_by.displayName} avatar" />
				</a>
			</div>
			<div class="slds-media__body">
				<header class="slds-media slds-media_center">
					<div class="slds-grid slds-grid_align-spread slds-has-flexi-truncate">
						<p>
							<a href="#" title="${reply.posted_by.displayName}">${reply.posted_by.displayName}</a>
						</p>
						${this.user && this.user.username === reply.username ? html`<button class="slds-button slds-button_icon slds-button_icon-border slds-button_icon-x-small" aria-haspopup="true" title="More Options">
							<svg class="slds-button__icon" aria-hidden="true">
								<use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#down"></use>
							</svg>
							<span class="slds-assistive-text">More Options</span>
						</button>` : ''}
					</div>
				</header>
				<div class="slds-comment__content slds-text-longform">${reply.comment_content}</div>
			${reply.files ? html`
				<div class="background slds-m-bottom_small">${this.getVideoOrImage(reply.files)}</div>
			` : ''}
			<footer>
				<ul class="slds-list_horizontal slds-has-dividers_right slds-text-body_small">
					<li class="slds-item">
						<button @click="${(e) => this.likeComment(reply, e)}" class="${reply.upvote ? 'slds-is-active ' : ''}slds-button_reset slds-text-color_weak" title="Like this item" aria-pressed="false">${this.getLikes(reply)}</button>
					</li>
					<li class="slds-item">
						<button @click="${(e) => this.dislikeComment(reply, e)}" class="${reply.downvote ? 'slds-is-active ' : ''} slds-button_reset slds-text-color_weak" title="Dislike this item" aria-pressed="false">${this.getDislikes(reply)}</button>
					</li>
					<li class="slds-item">
						<button @click="${() => this.toggleReplies(comment.id, reply.id)}" class="slds-button_reset slds-text-color_weak" title="Reply to this item" aria-pressed="false">Reply</button>
					</li>
					<li class="slds-item">${getTimePassed(reply.created)}</li>
				</ul>
			</footer>
		</div>
		`;
	}

	handleAttachFile(event) {
		event.preventDefault();
		// Select PNG, JPG, GIF, WEBP, WEBM or MP4 file
		const fileInput = this.shadowRoot.querySelector('#memeUpload');
    // Listen for file selection
    fileInput.onchange = (event) => {
      const file = event.target.files[0];
      if (file) {
				const formData = new FormData();
				formData.append("file", file);
				store.dispatch(uploadImage(formData));
      }
    };
		fileInput.click();
	}

	handleOrderSelected(e) {
		this.orderSelected = e.detail.value;
		this.requestUpdate("orderSelected");
		this.loadComments();
	}

	renderForm(id) {
		return html`
		<form @submit="${this.handleSubmit}">
			<div class="slds-media slds-comment slds-hint-parent">
				${this.user ? html`<div class="slds-media__figure">
					<a class="slds-avatar slds-avatar_circle slds-avatar_medium" href="/profile">
						<img alt="${this.user?.display_name}" src="${this.user?.profile_pic}" title="${this.user?.display_name} avatar" />
					</a>
				</div>` : ''}
				<div class="slds-media__body">
					<div class="slds-publisher slds-publisher_comment" id="${id}">
						<input class="slds-hide" type="file" id="memeUpload" name="memeUpload" accept="image/png, image/jpeg, image/jpg, image/gif, image/webp, video/webm, video/mp4" />
						<label for="${id}" class="slds-assistive-text">Write a comment</label>
						<textarea id="${id}" class="slds-publisher__input slds-input_bare slds-text-longform" placeholder="Write a comment…" autocomplete="off" @focus="${this.expandTextarea}" @blur="${this.collapseTextarea}"></textarea>
						<div class="slds-publisher__actions slds-grid slds-grid_align-spread">
						<ul class="slds-grid">
							<li>
							<button @click="${this.handleAttachFile}" class="slds-button slds-button_icon slds-button_icon-container" title="Attach a file">
								<svg class="slds-button__icon" aria-hidden="true">
								<use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#attach"></use>
								</svg>
								<span class="slds-assistive-text">Attach a file</span>
							</button>
							</li>
						</ul>
						<div class="slds-col_bump-left">
							<button class="slds-button slds-m-right_small" @click="${this.handleCancel}">Cancel</button>
							<button type="submit" class="slds-button slds-button_brand" ?disabled="${this.submitting||!this.user}">${this.submitting ? 'Posting...' : 'Post'}</button>
						</div>
						</div>
					</div>
				</div>
			</div>
			<div>
				${this.uploadedImage ? html`
					<div class="background slds-m-top_medium slds-m-left_xx-large slds-m-right_small">${this.getVideoOrImageUploadedImage(this.uploadedImage)}</div>
				` : ''}
			</div>
		</form>
		`;
	}

  render() {
    return html`
		<slds-combobox @option-selected="${this.handleOrderSelected}" .options="${this.orderOptions}" .selected="${this.orderSelected}" class="slds-show_inline-block"></slds-combobox>
		<div class="slds-feed">
		  <ul class="slds-feed__list slds-box slds-box_small slds-m-top_medium">
			${this.replyToCommentId === "" && (!this.hideTopForm || this.hideBottomForm) ? html`
			<li class="slds-feed__item slds-p-top_none">
				${this.renderForm("comment-text-input-01")}
			</li>
			` : ''}
		    ${this.comments.length === 0 ? html`<li class="slds-text-heading_medium slds-text-align_center slds-p-top_xx-large slds-p-bottom_xx-large">No comments yet…</li>` : this.comments.map(comment => html`
		    <li class="slds-feed__item">
		      <article class="slds-post">
						<single-comment .item="${comment}" .statusLookup="${this.statusLookup}" @toggle-replies="${(e) => this.toggleReplies(e.detail.commentId)}"></single-comment>
		      </article>
					${comment.comment_count > 0 ? html`<div class="slds-feed__item-comments slds-m-left_medium slds-m-right_medium">
						<div class="slds-p-horizontal_medium slds-p-vertical_x-small slds-grid">
							<button @click="${() => this.loadReplies(comment.id, comment.expanded)}" class="slds-button_reset slds-text-link">
								${comment.expanded ? html`
								<svg class="slds-icon slds-current-color slds-icon_x-small slds-align-middle" aria-hidden="true">
									<use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#arrowup"></use>
								</svg>` : html`
								<svg class="slds-icon slds-current-color slds-icon_x-small slds-align-middle" aria-hidden="true">
									<use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#arrowdown"></use>
								</svg>`}
								${comment.expanded ? 'Hide' : 'View'} ${comment.comment_count} replies
							</button>
						</div>
					</div>` : ''}
		      ${comment.replies && comment.comment_count > 0 ? html`<div class="slds-feed__item-comments slds-m-left_medium slds-m-right_medium">
		        <ul>
		          ${comment.replies && comment.comment_count > 0 ? html`
		          ${comment.replies.map(reply => html`
		          <li>
		            <article class="slds-comment slds-media slds-hint-parent">
		              ${this.renderReply(comment, reply)}
		            </article>
		          </li>
				  ${this.replyToCommentId === reply.id ? html`
				  <li class="slds-feed__item slds-p-top_none">
					  ${this.renderForm("comment-text-input-01")}
				  </li>
				  ` : ''}
		          `)}
		          ` : ''}
		        </ul>
		      </div>` : ''}
		    </li>
			${this.replyToCommentId === comment.id ? html`
			<li class="slds-feed__item slds-p-top_none">
				${this.renderForm("comment-text-input-01")}
			</li>
			` : ''}
		    `)}
				${(this.totalCommentCount > 5 && this.replyToCommentId==="") ? html`<li class="slds-feed__item slds-p-top_none">
					${this.renderForm("comment-text-input-02")}
				</li>` : ''}
		  </ul>
		</div>
		`;
	}
}